export default __webpack_public_path__ + "static/media/logoAurea2.a59f28bc.png";